import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ChordChangeActivePage } from './pages/ChordChangeActivePage';
import { ChordChangeSetupPage } from './pages/ChordChangeSetupPage';
import { ChordDetailPage } from './pages/ChordDetailPage';
import { ChordsLibraryPage } from './pages/ChordsLibraryPage';
import { CleanChordPage } from './pages/CleanChordPage';
import { HomePage } from './pages/HomePage';
import { ProgressPage } from './pages/ProgressPage';
import { RhythmPage } from './pages/RhythmPage';
import { SessionCompletePage } from './pages/SessionCompletePage';
import { StrummingPage } from './pages/StrummingPage';
import { TrainingModesPage } from './pages/TrainingModesPage';
import { TunerPage } from './pages/TunerPage';
import { DebugPanel } from './components/DebugPanel';

export function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/training" element={<TrainingModesPage />} />
        <Route path="/training/chord-change" element={<ChordChangeSetupPage />} />
        <Route path="/training/chord-change/run" element={<ChordChangeActivePage />} />
        <Route path="/training/clean-chords" element={<CleanChordPage />} />
        <Route path="/training/rhythm" element={<RhythmPage />} />
        <Route path="/training/strumming" element={<StrummingPage />} />
        <Route path="/tuner" element={<TunerPage />} />
        <Route path="/chords" element={<ChordsLibraryPage />} />
        <Route path="/chords/:chordId" element={<ChordDetailPage />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/session/complete" element={<SessionCompletePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <DebugPanel />
    </Router>
  );
}
